import { render } from "./OldMermaidChart.vue?vue&type=template&id=4ba4f2c2&scoped=true"
import script from "./OldMermaidChart.vue?vue&type=script&lang=js"
export * from "./OldMermaidChart.vue?vue&type=script&lang=js"

import "./OldMermaidChart.vue?vue&type=style&index=0&id=4ba4f2c2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ba4f2c2"]])

export default __exports__